<script>
import NewMatchDetail from '@/tbs/model/to/NewMatchDetail'
import RecentGames from '@/components/new-match-detail/RecentGames.vue'
import MatchGroup from '@/components/new-match-detail/MatchGroup.vue'
import NewsAnnouncement from '@/components/new-match-detail/NewsAnnouncement.vue'
import BasicInfo from '@/components/new-match-detail/BasicInfo.vue'
import Regulations from '@/components/new-match-detail/Regulations.vue'
import Registration from '@/components/new-match-detail/Registration.vue'
import ScoreAnnouncement from '@/components/new-match-detail/ScoreAnnouncement.vue'
export default {
  components: {
    RecentGames,
    MatchGroup,
    NewsAnnouncement,
    BasicInfo,
    Regulations,
    Registration,
    ScoreAnnouncement
  },
  props: {
    information: {
      type: Object,
      required: true
    },
    items: {
      type: [Array,Object,String],
      default: () => null
    }
  },
  data() {
    return {
      locale: new NewMatchDetail
    }
  },
  methods: {
    onMoreClick() {
      this.$router.push(this.information.router)
    },
    /** items 为空时返回 true，兼容 Array / Object / String */
    isEmpty(val) {
      if (val == null) return true
      if (Array.isArray(val)) return val.length === 0
      if (typeof val === 'object') return Object.keys(val).length === 0
      if (typeof val === 'string') return val.trim() === ''
      return false
    }
  },
  computed: {
    /** emptyDataShow 为 true 时始终展示；为 false 时仅在有数据时展示 */
    shouldShowContent() {
      const emptyDataShow = Boolean(this.information && this.information.emptyDataShow)
      if (emptyDataShow) return true
      return !this.isEmpty(this.items)
    }
  }
};
</script>
<template>
  <div class="content-box bg2 padding-12" v-if="shouldShowContent">
    <div class="title flex justify-between vertical-center">
      <div class="name font-color1">{{ information.name }}</div>
      <div class="more font-color3" v-if="information.router" @click="onMoreClick">{{ locale.localeProp('more') }}</div>
    </div>
    <div class="component">
      <RecentGames v-if="information.component === 'RecentGames'" :list="items" />
      <MatchGroup v-if="information.component === 'MatchGroup'" :list="items" />
      <NewsAnnouncement v-if="information.component === 'NewsAnnouncement'" :list="items" />
      <BasicInfo v-if="information.component === 'BasicInfo'" :info="items" />
      <Regulations v-if="information.component === 'Regulations'" :info="items" />
      <Registration v-if="information.component === 'Registration'" :info="items" />
      <ScoreAnnouncement v-if="information.component === 'ScoreAnnouncement'" :list="items" />
    </div>
  </div>
</template>

<style src="@/tbs/stylesheet/dynamic.css" />
<style scoped lang="scss">
.title {
  margin-bottom: 12px;
  .name { font-size: 15px; }
  .more { font-size: 12px; }
}
</style>
